import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CertificateState } from "../objects/certificate-state";
import { InsuranceCertificate } from "../objects/insurance-certificate";

const initialState: CertificateState = {
    selected_certificate: null,
    certificate_search: null,
    certificate_list: [],
};

export const certificate = createSlice({
    name: 'certificate',
    initialState,
    reducers: {
        setSelectedCertificate: (state: CertificateState, action: PayloadAction<InsuranceCertificate | null>): CertificateState => ({
            ...state, selected_certificate: action.payload
        }),
        setCertificateList: (state: CertificateState, action: PayloadAction<InsuranceCertificate[]>): CertificateState => ({
            ...state, certificate_list: action.payload
        }),
        setCertificateSearch: (state: CertificateState, action: PayloadAction<string | null>): CertificateState => ({
            ...state, certificate_search: action.payload
        }),
    }
});

export const {
    setSelectedCertificate,
    setCertificateList,
    setCertificateSearch,
} = certificate.actions;